import type { IFilter } from '@models/Filter'
import type { Query } from '@models/Query'

import { apiClient } from '../../../gateways/api'
import type { FetchKpi, FetchKpiFilters } from '../types/FetchKpi'

export { fetchKpi, createFilters, initialState }

const fetchKpi = async ({
  query,
}: {
  query: Query<FetchKpiFilters>
}): Promise<FetchKpi['data']> => {
  const { filters } = query

  const { data } = await apiClient({
    url: '/rest/dashboard/aansluiting/kpi',
    method: 'POST',
    data: { filters: createFilters(filters) },
  })

  return data
}

const createFilters = ({
  gebied,
  netbeheerder,
  labels,
  myList,
}: FetchKpiFilters) => {
  const filters: IFilter[] = []

  if (gebied && gebied.length > 0)
    filters.push({
      name: 'gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })
  if (netbeheerder)
    filters.push({ name: 'netbeheerders', value: netbeheerder, operator: 'eq' })
  if (labels && labels.length > 0)
    filters.push({
      name: 'labels',
      value: labels.map(({ code }) => code),
      operator: 'in',
    })

  if (myList) {
    filters.push({ name: 'my-list', value: true, operator: 'eq' })
  }

  return filters
}

const initialState: FetchKpi = {
  data: [],
  query: {
    filters: {
      gebied: [],
      netbeheerder: null,
      coordinerende: null,
      labels: [],
      myList: false,
    },
  },
}
